import { GamePlayConfig } from 'shared-services'
import { GamePlayService } from './game-play.service'
import { GamePlay } from '../models/game-play'

export class GamePlayPollingService {
  private hasGamePlayPollingIntervalId = setTimeout(() => {})
  private pollingHandler: (gamePlay: GamePlay | undefined) => void = () => {}
  private isPolling = false

  public constructor(
    private readonly gamePlayService: GamePlayService,
    private readonly gamePlayConfig: GamePlayConfig,
  ) {}

  public async startPollingForGamePlay(
    handler: (gamePlay: GamePlay | undefined) => void,
  ): Promise<void> {
    this.pollingHandler = handler

    this.hasGamePlayPollingIntervalId = setInterval(async () => {
      await this.findGamePlayAndHandle(handler)
    }, this.gamePlayConfig.getGamePlayPollTimeoutInMilliseconds)

    this.isPolling = true
  }

  public stopPollingForHasGamePlay(): void {
    this.pollingHandler = () => {}
    this.isPolling = false
    clearInterval(this.hasGamePlayPollingIntervalId)
  }

  public async onGameUpdated(
    handler: (gamePlay: GamePlay | undefined) => void,
  ): Promise<void> {
    await this.findGamePlayAndHandle((gamePlay) => {
      this.pollingHandler(gamePlay)
      handler(gamePlay)
    })
  }

  public getIsPolling(): boolean {
    return this.isPolling
  }

  private async findGamePlayAndHandle(
    handler: (gamePlay: GamePlay | undefined) => void,
  ): Promise<void> {
    const gamePlay = await this.gamePlayService.findGamePlay()
    handler(gamePlay)
  }
}
